<h2 mat-dialog-title>Tutorial 6 - Assistenza e Gestione account</h2>

    <mat-dialog-content>

      <p>Crediamo fermamente nel supporto umano e nell'ascolto. Noi di {{ sourceLabels[data.organization.source || ''] || 'Beizy' }} siamo a disposizione se hai bisogno di aiuto durante la tua avventura da forfettario.</p>
      <p>In ogni caso, la maggior parte delle operazioni può essere svolta in autonomia. Puoi rivedere i tutorial precedenti se hai dubbi sulle funzioni principali, oppure puoi vedere i tuoi documenti e pagamenti direttamente in App. Vediamo insieme cosa puoi fare.</p>
      <h6>Il tuo profilo</h6>
      <p>Per accedere al tuo profilo, raggiungi la sezione
        <span class="inline-icon">
          <mat-icon>account_box</mat-icon> 
        </span>
      <u class="component-link" (click)="goToProfile()">Profilo</u>
      dal menù.</p>
      <p>Nella tua pagina profilo di {{ sourceLabels[data.organization.source || ''] || 'questa App' }}, vedrai due schede principali:</p>
      <ul>
        <li><strong>Utente:</strong> qui vedrai i dati con cui hai effettuato l'accesso all'App. Vedrai i dati del tuo abbonamento, il Servizio attivo e la scadenza. In basso, cliccando su 
          <span class="inline-icon">
            <mat-icon>receipt_long</mat-icon> 
          </span>
        <strong>Vedi pagamento</strong> puoi consultare i dati del tuo ultimo pagamento registrato e vedere o stampare la ricevuta completa in PDF. Inoltre, nella sezione 
          <span class="inline-icon">
            <mat-icon>manage_accounts</mat-icon> 
          </span>
          <strong>Gestisci abbonamento</strong> puoi modificare alcune opzioni del tuo abbonamento e vedere il tuo contratto firmato di {{ sourceLabels[data.organization.source || ''] || 'questo Servizio' }}.
        </li>
        <li><strong>Organizzazione:</strong> qui puoi vedere i dati che riguardano la tua Partita IVA. Da qui puoi richiedere la modifica dei tuoi dati (tramite il nostro servizio di assistenza) o cambiare la foto profilo. Questa foto, se presente, apparirà sulle fatture che crei in PDF tramite l'App e su quelle che invii ai clienti tramite il nostro servizio di email. Dalla sezione
          <span class="inline-icon">
            <mat-icon>settings</mat-icon> 
          </span>
          <strong>Impostazioni predefinite</strong> puoi modificare alcuni settaggi predefiniti che ti velocizzano durante la creazione di fatture o che completano il tuo profilo. Più in basso, nella sezione
          <span class="inline-icon">
            <mat-icon>group_add</mat-icon>
          </span>
          <strong>Inviti Organizzazione</strong> vedi gli inviti attivi al tuo profilo. Questa funzione è molto importante, perchè ti permette di vedere quali utenti hai autorizzato a consultare il tuo profilo! Puoi creare nuovi inviti quando lo desideri, e inviare il link che generiamo per te all'utente che hai scelto, indicando la mail. Se l'utente farà l'accesso con quella mail esatta e accetterà l'invito, sarà a bordo insieme a te. Potrà, da questo momento, effettuare tutte le operazioni che l'App di {{ sourceLabels[data.organization.source || ''] || '' }} ti permette, compresa la fatturazione. Scegli quindi bene chi vuoi far accedere!
        </li>
      </ul>
      <h6>I tuoi documenti</h6>
      <p>Quando il tuo account è stato creato, insieme all'apertura della Partita Iva, ci hai inviato alcuni documenti personali. Tramite la sezione
        <span class="inline-icon">
          <mat-icon>library_books</mat-icon> 
        </span>
      <u class="component-link" (click)="goToDocuments()">Documenti</u>
      puoi rivedere tutti i tuoi documenti presenti all'interno nostro Sistema, ed eventualmente leggere pure qui il contratto firmato del Servizio. Qui vedrai anche eventuali documenti che il Commercialista potrebbe aver richiesto in fase di registrazione, come Certificazioni Uniche o altro.</p>
      <h6>Notifiche e avvisi</h6>
      <p>Nel menù noterai la voce 
        <span class="inline-icon">
          <mat-icon>mail</mat-icon> 
        </span>
      <u class="component-link" (click)="goToMessages()">Notifiche e avvisi</u>
        con accanto un piccolo <i>badge</i> che mostra il numero di nuove notifiche non lette. Qui troverai notifiche da parte nostra sia su novità del Servizio sia sulla fatturazione elettronica, come ad esempio quando una fattura viene scartata o il tuo abbonamento è in scadenza.
      </p>
      <h6>Hai bisogno di assistenza?</h6>
      <p>A volte, un po' di supporto umano è tutto ciò che serve. Che sia un problema tecnico con la fatturazione elettronica o una domanda per uno dei nostri Commercialisti, siamo qui.</p>
      <p>Puoi contattarci in qualsiasi momento, attraverso il nostro indirizzo mail o il numero verde.</p>

      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>La nostra mail</mat-label>
          <input 
            matInput 
            [value]="helpEmail" 
            readonly
            #linkInput>
          <button 
            mat-icon-button 
            matSuffix 
            (click)="copyToClipboard()"
            [attr.aria-label]="'Copia link'">
            <mat-icon>content_copy</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Il nostro numero verde</mat-label>
          <input 
            matInput 
            [value]="helpNumber" 
            readonly
            #linkInput>
          <button 
            mat-icon-button 
            matSuffix 
            (click)="copyNumberToClipboard()"
            [attr.aria-label]="'Copia numero'">
            <mat-icon>content_copy</mat-icon>
          </button>
        </mat-form-field>
      </div>
    <p class="mt-4">Speriamo di esserti stati d'aiuto.</p>
    <p class="ms-4"><i>Il Team di {{ sourceLabels[data.organization.source || ''] || '' }}</i></p>


    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>
        <mat-icon>check</mat-icon>
        Ok, torna ai tutorial
      </button>
    </mat-dialog-actions>
